import React from "react";
import { ITaskCycleControlProps, useTaskCycleControlController } from "./hooks/useTaskCycleControlController";
import { TaskCycleControlView } from "./components/TaskCycleControlView";

// Start Resubmission action for a task (controller/hook/view pattern) - wording in taskCycle.ts.
// There is no picker: every cycle is listed in the subtask column, so choosing one is choosing a
// subtask.
export default function TaskCycleControl(props: ITaskCycleControlProps) {
    const ctrl = useTaskCycleControlController(props);
    return <TaskCycleControlView {...ctrl} />;
}
